import { getUser } from 'redux/authentication/auth.slice';
import { useAppSelector } from 'redux/hooks';

interface Props {
  // teacher: Component
  [key: string]: any;
}

// Default return component
const emptyFunction = () => undefined;

// Function that expect object in order -> 'user_role': 'Component that we want to be rendered for the provided user role'
// If none is provided it will render emptyComponent from the above
function CallWithRole(data: Props) {
  const user = useAppSelector(getUser);
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(data)) {
    if (key === user.role) {
      return value;
    }
  }
  return emptyFunction;
}

export default CallWithRole;
